import { Box } from "@mui/material";
import BloqueVista from "../../components/public/BloqueVista";
import { sxColumnaContenido } from "../../components/public/ContenidoNavegable";

/** "Preguntas frecuentes" dentro de la app (`/app/preguntas`): los mismos
 *  bloques que la página pública, sin tener que salirse de la sesión. */
export default function Preguntas() {
  return (
    <Box>
      <BloqueVista clave="preguntas" conIndice editable />
      <Box sx={sxColumnaContenido}>
        <BloqueVista clave="coordinadores" alPie editable />
      </Box>
    </Box>
  );
}
